import { useField } from 'formik';
import { useMemo } from 'react';
import { get } from 'ui/lodash';
import { mapProductImage } from 'components/store/utils';
import { useProduct } from 'components/products/context';

export function useAssets() {
  const product = useProduct();
  const [{ value: variantId }] = useField('variantId');
  const [{ value: colorId }] = useField('colorId');

  const assets = useMemo(() => {

    const {
      variants = [],
      colors = []
    } = product;

    const images = get(product, 'images', [])
      .map(mapProductImage);
    const videos = get(product, 'videos', [])
      .map(x => ({
        ...x,
        type: 'video'
      }));

    const files = [...images, ...videos];

    const variant = variants.find(x => x._id === variantId);
    if (variant && variant?.images?.length) {
      files.unshift(...variant.images);
    }
    const color = colors.find(x => x.hex === colorId);

    if (color && color?.images?.length) {
      files.unshift(...color.images);
    }

    return files;
  }, [variantId, colorId, product._id]);

  return assets;
}

export function useSelectedVariant() {
  const product = useProduct();
  const [{ value: variantId }] = useField('variantId');
  const selectedVariant = (product?.variants || []).find(x => x._id === variantId);
  return selectedVariant ?? null;
}
